export const PAYOFFS = [
  {
    key: 'payoff',
    displayValue: 'Payoff',
  },
  {
    key: 'shortDescription',
    displayValue: 'Short Description',
  },
];
